module.exports = __webpack_public_path__ + "img/UHF-DVS-50.74057f32.png";